import React, { useState, useEffect, useRef } from "react";
import queryString from "query-string";
import { Form, Progress, Alert, Input, Row, Col, Button, Container } from "reactstrap";
import { CSSTransition } from "react-transition-group";

import { useLocalization } from "../../containers/I18nProvider";
import { WithCaptcha } from '../../containers/captcha';

import logo from './img/logo.png'

const LoginForm = ({ api, location, TurnstileComponent, ...props }) => {
  const nodeRef = useRef(null);
  const { translate } = useLocalization();
  const [onLogin, setOnLogin] = useState(false);
  const [showForm, setShowForm] = useState(false);
  const [error, setError] = useState({
    open: false,
    message: "",
  });
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");

  const parameters = queryString.parse(location.search);
  parameters.idp = 'mts';

  useEffect(() => {
    setShowForm(true)
  }, []);

  const onSubmit = async (ev) => {
    ev.preventDefault();
    setOnLogin(true)
    setError({
      open: false,
      message: "",
    })

    api.userPassLogin(
      {
        username,
        password,
      },
      parameters
    )
      .then((response) => {
        setOnLogin(false)
        window.location = parameters.redirect_uri + "?" + queryString.stringify(response);
      })
      .catch((error) => {
        const _translate = translate(error.errorCode);

        let message = "Usuario y/o contraseña inválidos.";

        if (_translate) {
          message = _translate;
        } else if (error.details) {
          message = error.details;
        }
        setOnLogin(false)
        setError({ open: true, message: message })
      });
  }

  return (
    <CSSTransition
      in={showForm}
      timeout={300}
      classNames="formshow"
      nodeRef={nodeRef}
      unmountOnExit
    >
      <div className="login-mts-container" ref={nodeRef}>
        <img src={logo} alt="logo" className="logo-mts rounded mx-auto d-block" />
        <Container fluid={true} className="mts-form-container">
          <Form onSubmit={(event) => onSubmit(event)}>
            <div className="mts-field">
              <label className="mts-label">
                <Input
                  className="mts-input"
                  disabled={onLogin}
                  required={true}
                  tabIndex={1}
                  type="text"
                  autoCorrect="off"
                  autoCapitalize="none"
                  id="mts-username"
                  onChange={e => setUsername(e.target.value)}
                />
                <span id="label-username">{translate("PlaceholderUserName")}</span>
              </label>
            </div>
            <div className="mts-field">
              <label className="mts-label">
                <Input
                  className="mts-input"
                  required={true}
                  disabled={onLogin}
                  tabIndex={1}
                  type="password"
                  autoCorrect="off"
                  autoCapitalize="none"
                  id="mts-password"
                  onChange={e => setPassword(e.target.value)}
                />
                <span id="label-password">{translate("PlaceholderPassword")}</span>
              </label>
            </div>
            <Row style={{ padding: 0 }}>
              <Col className="mts-field mts-btn" style={{ textAlign: 'center' }}>
                <Button
                  block={!parameters.failureRedirect}
                  tabIndex={1}
                  type="submit"
                  id="submmit"
                  className="enter-mts"
                  disabled={onLogin || !props.turnstileSuccess}
                >
                  {translate("ButtonEnter")}
                </Button>

              </Col>
            </Row>
            {onLogin && <Progress animated color="danger" value={100} style={{ marginTop: '20px' }} />}
            <div className="messages-container">
              <Alert
                color="danger"
                id="error-message"
                isOpen={error.open}
                toggle={() => setError({ open: false })}
              >
                {error.message}
              </Alert>
            </div>
          </Form>
        </Container>
        <TurnstileComponent setTurnstileSuccess={props.setTurnstileSuccess} />
      </div>
    </CSSTransition>
  );
}

export default WithCaptcha(LoginForm, { useInsideForm: true, style: { marginTop: '2rem' } });
